import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useSearchOverlayStore } from '../_store/searchOverlayStore';
export function usePageSearchBarVisibility() {
  const $ = _c(3);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const target = ref.current;
      if (!target) {
        return;
      }
      const {
        setPageSearchBarVisible,
        reset
      } = useSearchOverlayStore.getState();
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        if (!entry) {
          return;
        }
        setPageSearchBarVisible(entry.isIntersecting);
      });
      observer.observe(target);
      return () => {
        observer.disconnect();
        reset();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ref
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}